import { useCallback, useEffect, useMemo, useState } from "react";
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from "react-redux";
import { getStatus } from "@/store/slices/helpers/helpers";
import { clearData, fetchData } from "@/store/slices/fetch-slice";
import { apiKeys, apiMethods, apiUrls } from "@/store/api/constants";
import { getEncoded } from "@/common/helpers/helpers";
import navs from "@/from-theme/routes/constants/nav";
import { useNavigate } from "react-router";

export default function useOnActions() {
  const [isAlertDialog, setIsAlertDialog] = useState(false);

  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const state = useSelector((store) => store);
  const [currentRowId, setCurrentRowId] = useState(null);

 

  const deleteCompetitorMasterStatus = getStatus(state, apiKeys.deleteCompetitorMaster, '');

  const onCloseAlert = useCallback(() => {
    setIsAlertDialog((prevState) => !prevState);
    setCurrentRowId(null);
  }, []);

  const onAgreeAlert = useCallback(() => {
    dispatch(fetchData({
      url: apiUrls.deleteCompetitorMaster(currentRowId),
      method: apiMethods.DELETE,
      key: apiKeys.deleteCompetitorMaster,
      successMsg: formatMessage({ id: "competitor-master-has-been-deleted-successfully" }),
      failureMsg: formatMessage({ id: "failed-to-delete-competitor-master" }),
    }))
    onCloseAlert();
  }, [dispatch, formatMessage, onCloseAlert, currentRowId]);


  const onRowDelete = useCallback((id) => {
    setCurrentRowId(id);
    setIsAlertDialog(true);
  }, []);

  const onRowEdit = useCallback((id) => {
    // navigate(navs.editIfdCompetitorMaster(getEncoded(id)))
    navigate(navs.editSchemesNonEligibleListMaster(getEncoded(id)))
  }, [navigate])

  useEffect(() => () => {
    dispatch(clearData({ key: apiKeys.deleteCompetitorMaster }));
  }, [dispatch]);


  return useMemo(() => ({
    onRowEdit,
    onRowDelete,
    deleteCompetitorMasterStatus,
    isAlertDialog,
    onCloseAlert,
    onAgreeAlert
  }), [
    onRowEdit,
    onRowDelete,
    deleteCompetitorMasterStatus,
    isAlertDialog,
    onCloseAlert,
    onAgreeAlert,
  ])
}
